@if (version.updateAvailable() && !version.updating() && !version.clearingCache()) {
  <div class="fixed inset-x-0 top-0 z-[9999] bg-slate-950 text-white shadow-xl">
    <div class="px-4 py-3">
      <p class="text-sm font-semibold">{{ version.forceUpdate() ? 'Worker portal update required.' : 'Worker portal update available.' }}</p>
      <p class="mt-0.5 text-xs text-slate-300">Update to {{ version.latestVersion() }} so job, project, and shift tools stay current.</p>
      <button type="button" (click)="version.reload()" [disabled]="version.updating() || version.clearingCache()" class="mt-3 h-10 w-full rounded-xl bg-white text-sm font-semibold text-slate-950 disabled:opacity-60">
        {{ version.updating() ? 'Installing update...' : 'Update now' }}
      </button>
      <button type="button" (click)="version.clearCacheAndRefresh()" [disabled]="version.clearingCache() || version.updating()" class="mt-2 h-10 w-full rounded-xl border border-white/25 text-sm font-semibold text-white disabled:opacity-60">
        {{ version.clearingCache() ? 'Clearing cache...' : 'Clear cache & refresh' }}
      </button>
    </div>
  </div>
}
@if (session.expired()) {
  <div class="fixed inset-0 z-[10000] flex items-center justify-center bg-slate-950/65 p-4" role="alertdialog" aria-modal="true" aria-labelledby="session-expired-title">
    <section class="w-full max-w-sm rounded-[28px] bg-white p-6 text-center shadow-2xl">
      <div class="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-50 text-amber-600">
        <i class="ti ti-lock-exclamation text-3xl"></i>
      </div>
      <h2 id="session-expired-title" class="mt-4 text-xl font-bold text-slate-900">Your session has expired</h2>
      <p class="mt-2 text-sm leading-6 text-slate-600">For your security, please sign in again to continue. Your saved shift and job records are not affected.</p>
      <button type="button" (click)="signInAgain()" class="mt-6 h-12 w-full rounded-xl bg-[#102C57] text-sm font-bold text-white active:scale-[0.99]">
        Sign in again
      </button>
    </section>
  </div>
}
<router-outlet />
<app-install-app />
